import {isMobile, isTablet} from "../components/helpers";

export function initTemplateLanding() {
    if (!$('#template_landing').length) return;

    const divs = $('body').find('div.lozad');

    divs.each((i, div) => {
        const width = $(div).attr('width')
        const height = $(div).attr('height')
        const ratio = height / width * 100

        if ($(div).hasClass('picture')) {
            if (isMobile() || isTablet()) {
                $(div).css({
                    'padding-top': ratio + '%'
                })
            } else {
                $(div).css({
                    'padding-top': 'calc(' + ratio + '% / 2)'
                })
            }

        } else if ($(div).hasClass('iphone-plug')) {
            if (isMobile() && !isTablet()) {
                $(div).css({
                    'padding-top': ratio + '%'
                })

            } else if (!isMobile() && isTablet()) {
                $(div).css({
                    'padding-top': 'calc(' + ratio + '% / 3)'
                })

            } else {
                $(div).css({
                    'padding-top': 'calc(' + ratio + '% / 3)'
                })
            }
        } else {
            $(div).css({
                'padding-top': ratio + '%'
            })
        }
    })

}
